// Onboarding version tracking
// Increment this when adding new onboarding content that existing users should see

export const CURRENT_ONBOARDING_VERSION = 2;

// Version history:
// 1 - Initial onboarding (Welcome, Calls, Friends, Groups)
// 2 - Added Insights step (track trends + share to social media)
